import React from 'react';
import BeatLoader from 'react-spinners/BeatLoader';

const LoadingSpinner = ({ size = 'medium', color = 'primary', text = '', className = '' }) => {
  const sizeMap = { small: 8, medium: 12, large: 16 };
  const colorMap = { primary: '#3B82F6', secondary: '#6B7280', white: '#FFFFFF' };
  const loaderSize = sizeMap[size] || sizeMap.medium;
  const loaderColor = colorMap[color] || colorMap.primary;
  const containerMinHeight = size === 'medium' || size === 'large' ? 'min-h-[50vh]' : '';
  return (
    <div className={`flex flex-col items-center justify-center w-full ${containerMinHeight} ${className}`}>
      <BeatLoader color={loaderColor} size={loaderSize} loading={true} />
      {text && <p className="mt-3 text-gray-600 text-sm text-center">{text}</p>}
    </div>
  );
};

export default LoadingSpinner;